import { graphql } from "gatsby"
import React from "react"
import Layout from "../layouts/Layout"
import SiteMetadata from "../components/SiteMetadata"
import CardsGrid from "../components/grids/CardsGrid"
import PageHeader from "../components/sections/PageHeader"
import MediumCTA from "../components/cta/MediumCTA"

const CaseStudies = ({ data }) => {
  return (
    <Layout>
      <SiteMetadata title="Case Studies" description="Get a taste of the success I’ve achieved for my clients as a publicist and social media strategist." />
      <PageHeader heading="See how I’ve achieved success for my clients" />

      <div className="py-6 lg:py-8">
        {data.caseStudy && data.caseStudy.nodes.length > 0 ? (
          <CardsGrid items={data.caseStudy.nodes} />
        ) : (
          <div className="container">
            <h2 className="text-center">No case studies yet.</h2>
            <p className="body-text-lg text-center">
              Please check back in soon
            </p>
          </div>
        )}
      </div>

      <MediumCTA />
    </Layout>
  )
}

export default CaseStudies

export const query = graphql`
  query CaseStudiesQuery {
    caseStudy: allContentfulCaseStudy(
      filter: { hidden: { ne: true } }
      sort: { fields: order, order: ASC }
    ) {
      nodes {
        ...CaseStudyCard
      }
    }
  }
`
